import { NestedTreeControl } from '@angular/cdk/tree';

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable, startWith, takeUntil } from 'rxjs';
import { RolesTypeEnum } from 'src/formio-custom-components/src/lib/shared/model/roles';
import { CRITERION_TYPE } from '../../const';
import { ICriterion } from '../../models/criterion';
import { DistributeService } from '../../services/distribute.service';
import { BaseComponent } from '../base.component';
@Component({
  selector: 'app-criterions-tree',
  templateUrl: './criterions-tree.component.html',
  styleUrls: ['./criterions-tree.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CriterionsTreeComponent extends BaseComponent implements OnInit, OnChanges {
  @Output() changeCriterion = new EventEmitter<ICriterion>();
  @Input() criterions: ICriterion[] = [];

  selectedNode: ICriterion = null;
  treeControl = new NestedTreeControl<ICriterion>((node) => node?.subCriteria);

  dataSource: MatTreeNestedDataSource<ICriterion>;

  readonly hasChild = (_: number, node: ICriterion) => {
    if (this.userRole === RolesTypeEnum.MASAR) {
      return !!node.subCriteria && !!node.subCriteria.length;
    }
    return (
      !!node.subCriteria &&
      node.subCriteria.filter((itm) => itm.criterionType !== CRITERION_TYPE).length > 0
    );
  };

  //&&
  //
  readonly trackBy = (_: number, node: ICriterion) => node.id;

  lang: string;
  constructor(
    private distributeService: DistributeService,
    public translateService: TranslateService
  ) {
    super();
    (this.translateService.onLangChange as Observable<LangChangeEvent>)
      .pipe(
        startWith({
          lang: this.translateService.currentLang,
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((res) => {
        this.lang = res.lang;
      });
  }

  ngOnInit(): void {
    this.dataSource = new MatTreeNestedDataSource<ICriterion>();
    this.dataSource.data = this.criterions;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.criterions && this.dataSource) {
      this.dataSource.data = null;
      this.dataSource.data = changes.criterions.currentValue;
      this.expand(this.dataSource.data, this.selectedNode.id);
    }
  }

  rowClicked(node: ICriterion) {
    if (this.selectedNode?.id !== node?.id) {
      this.selectedNode = node;
      this.changeCriterion.emit(node);
    }
  }

  expand(data: ICriterion[], id: number): any {
    data.forEach((node) => {
      if (node.subCriteria && node.subCriteria.find((c) => c.id === id)) {
        this.treeControl.expand(node);
        this.expand(this.dataSource.data, node.id);
      } else if (node.subCriteria && node.subCriteria.find((c) => c.subCriteria)) {
        this.expand(node.subCriteria, id);
      }
    });
  }
}
